var $ = window.jQuery

export default function() {
  // tooltips slidetoggle 
  if($('.acf-label .description')[0]) {
    $('.acf-label .description').before('<div class="trigger-tooltip"><svg><use xlink:href="' + tofinoJS.themeUrl + '/dist/svg/sprite.symbol.svg#question"></use></svg></div>');
  
    //replace p with div and span with p inside description
    $('.acf-label p.description').each(function () {
      $(this).replaceWith('<div class="description">' + $(this).html() + '</div>')
    })
    
    $('.acf-label div.description').each(function () {
      $(this).find('span').each(function() {
        $(this).replaceWith('<p>' + $(this).html() + '</p>')
      })
    })
  
    $('.trigger-tooltip').on('click', function () {
      $(this).closest('.acf-label').find('.description').slideToggle('fast');
    });
  }
}
